export default __webpack_public_path__ + "static/media/motorik.07e5745f.png";